<script>
    import axios from 'axios'
    import {Listeners} from "../../../constants/listeners";
    import {nextTick} from "vue";
    import Button from "primevue/button";
    import Checkbox from "primevue/checkbox";
    import ActionsContainer from "./actions-container.vue";

    export default {
        data() {
            return {
                rollUp: false,
                style: {},
                selectedTo: [],
                model: {}
            }
        },
        props: ['reportRid', 'type'],
        mounted: function () {
            this.$emitter.on(Listeners.KS_TABLE_CHECKBOX_SELECTED, eventData => this.selectedTo = eventData);
        },

        methods: {
            deleteSelected(){
                let self = this;
                this.$emitter.emit(Listeners.GLOBAL_PRELOADER_SHOW);
                axios({
                    method: 'post',
                    url: this.getApiUrl,
                    withCredentials: true,
                    data: Object.assign({}, this.model, {keys: self.selectedTo})
                })
                    .then(function (response) {
                        self.$emitter.emit(Listeners.GLOBAL_PRELOADER_HIDE);
                        if(response.status === 200){
                            self.clearSelectedTo();
                            self.refreshTable();
                        }else{
                            window.location.reload();
                        }

                    })
                    .catch(function (error) {
                    });


            },

            clearSelectedTo(){
                this.$emitter.emit(Listeners.KS_TABLE_CLEAR_SELECTED_TO);
            },

            refreshTable(){
                this.$emitter.emit(Listeners.KS_FILTER_REFRESH);
            },

            handleScroll(){

                if(document.getElementsByClassName('ks-button-panel').length === 0){
                    return;
                }

                let table = document.getElementsByClassName('vuetable')[0],
                    panel = document.getElementsByClassName('ks-button-panel')[0];

                if((window.innerHeight - 200) >= (table.getBoundingClientRect().height + table.getBoundingClientRect().top + 70)){
                    this.style = {
                        top: (table.getBoundingClientRect().height + table.getBoundingClientRect().top + 70) + 'px',
                    }
                }else{
                    this.style = {
                        top: (window.innerHeight - 200) + 'px'
                    };
                }
            }

        },
        computed: {
            panelStyle(){
                return Object.assign({}, this.style, this.rollUp?{padding: '15px', opacity: 0.5}:{});
            },
            getApiUrl(){
                return this.$config.API_URL + '/report/group/delete/keys/' + this.reportRid;
            },

        },
        watch: {
            selectedTo: function () {
                let self = this;
                nextTick(() => {
                    self.handleScroll();
                });

            }
        },

        created: function () {
            window.addEventListener('scroll', this.handleScroll);
            this.handleScroll();
            this.model = {
                organic: this.type === "organic",
                context: this.type === "context",
            };

        },
        destroyed: function () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        components: {
            Button,
            Checkbox,
            ActionsContainer,
        }
    }
</script>

<template>
    <ActionsContainer :panelStyle="panelStyle" :selectedCount="selectedTo.length">
        <template #buttons>
            <Button
                :label="$t('lang.main.table.components.checkbox_keys_action.delete_selected')"
                @click="deleteSelected"
                size="small"
            />
            <Button
                :label="$t('lang.main.btn.clear')"
                @click="clearSelectedTo"
                severity="secondary"
                size="small"
            />
        </template>
        <template #footer>
            <div class="formgroup-inline">
                <div class="field-checkbox">
                    <Checkbox v-model="model.organic" inputId="organic" binary />
                    <label for="organic">{{ $t('lang.main.table.components.checkbox_keys_action.organic') }}</label>
                </div>
                <div class="field-checkbox">
                    <Checkbox v-model="model.context" inputId="context" binary />
                    <label for="context">{{ $t('lang.main.table.components.checkbox_keys_action.context') }}</label>
                </div>
            </div>
        </template>
    </ActionsContainer>
</template>

<style scoped>
.formgroup-inline {
    margin-bottom: -1.25rem;
}
</style>
